var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.66611L4 19.5981L20 19.5981L20 4.66611L22 4.66611L22 2.7996L2 2.7996L2 4.66611L4 4.66611ZM11 17.7316L9.5 17.7316L9.5 4.66611L11 4.66611L11 17.7316ZM13 4.66611L14.5 4.66611L14.5 17.7316L13 17.7316L13 4.66611ZM18 17.7316L16.5 17.7316L16.5 4.66611L18 4.66611L18 17.7316ZM7.5 4.66611L7.5 17.7316L6 17.7316L6 4.66611L7.5 4.66611Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3e520c9dbbe93f0056fcbf87efa3ad5b.svg";
export { ForwardRef as ReactComponent };